<div *ngIf="component !== 'fly'" class="row w-100 m-0" style="background-color: #FFFFFF; min-height: 65px;">
  <!-- First Column -->
  <div
    class="col-4 p-0"
  >
    <div style="border-right: 1px solid #dfdfdf;">
      <div class="px-2 py-3">
        <div class="row">
          <div class="col-4 pr-0">
            <p class="pl-2 mb-0 text-dark" style="font-family: 'Rubik'; font-size: 10.02px">
              Agregar información <br /> de Vuelo
            </p>
          </div>

          <!-- Open Flight Modal Button -->
          <div class="col-1">
            <div class="w-full d-flex align-items-center justify-content-center">
              <button
                type="button"
                class="btn btn-sm text-white"
                style="background-color: black; cursor: pointer"
                data-placement="bottom"
                (click)="openModalWithClass(template, 'new')"
                [disabled]="_actualItinerary === null"
              >
                <img style="filter: invert(1);" width="20px" height="20px" src="../../../assets/icons/itinerary/vuelo_vert.svg" alt="vuelo" />
              </button>
            </div>
          </div>

          <!-- Internal Flight Information -->
          <div
            *ngIf="flightsInternal && flightsInternal.length > 0"
            class="col-7 pl-2"
            style="cursor: pointer;"
            [ngStyle]="{ cursor: _actualItinerary?.flights.length > 1 ? 'pointer' : 'default' }"
          >
            <div class="d-flex align-items-end" style="gap: 2px;">
              <!-- FROM -->
              <div
                *ngIf="_actualItinerary?.flights[0]?.arrivalIn"
                class="d-flex gap-1 align-items-center justify-content-center"
                style="width: 35%; gap: 3px"
              >
                <p class="mb-0" style="font-family: 'Open Sans', serif; font-size: 10.91px; font-weight: bold">
                  {{ getActualFlyInternal(flightsInternal, "airportIataCodeOut") }}
                </p>
                <p class="mb-0" style="font-family: 'Open Sans', serif; font-size: 10.91px">
                  {{ getActualFlyInternal(flightsInternal, "departureOut") | date: "dd MMM yy" }}
                </p>
              </div>

              <!-- LINE -->
              <div class="d-flex flex-column align-items-center justify-content-center" style="width: 25%;">
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 10px; line-height: 1">
                  {{ afterDateFlyOut(getActualFlyInternal(flightsInternal, "departureOut"), getActualFlyInternal(flightsInternal, "arrivalOut")) }}
                </p>

                <div class="d-flex align-items-center w-100 justify-content-center">
                  <div style="height: 1px; border-bottom: 1px dotted #000000; width: 100%"></div>
                  <i class="fa fa-angle-right" style="font-size: 1rem" aria-hidden="true"></i>
                </div>
              </div>

              <!-- TO -->
              <div
                class="d-flex gap-1 align-items-center justify-content-center"
                style="width: 35%; gap: 3px"
                [ngStyle]="{ 'border-right': _actualItinerary?.flights[0]?.arrivalIn ? '1px solid #dfdfdf:' : '' }"
              >
                <p class="mb-0" style="font-family: 'Open Sans', serif; font-size: 10.92px; font-weight: bold">
                  {{ getActualFlyInternal(flightsInternal, "iataCityArrivalOut") }}
                </p>
                <p class="mb-0" style="font-family: 'Open Sans', serif; font-size: 10.92px">
                  {{ getActualFlyInternal(flightsInternal, "arrivalOut") | date: "dd MMM yy" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Second Column -->
  <div
    *ngIf="_actualItinerary?.flights && _actualItinerary?.flights.length > 0 && invoke === 1 && component !== 'fly'"
    class="col-8 p-0"
    (mouseenter)="changeTooltipFlightVisible(true)"
    (mouseleave)="changeTooltipFlightVisible(false)"
  >
    <!-- Flight Information -->
    <div class="d-flex align-items-center h-100 pl-3">
      <div class="d-flex justify-content-between align-items-center" style="cursor: pointer; width: 100%">
        <div *ngIf="_actualItinerary?.flights[0]?.arrivalIn" class="w-100 d-flex gap-1 align-items-center">
          <img class="ml-3 mr-2" width="28px" src="../../../../assets/icons/itinerary/AVIONLINEA.svg" alt="" />

          <p class="mb-0 ml-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 11px">
            <span style="font-weight: 600; color: #444f5d;">
              {{ _actualItinerary?.flights[0]?.arrivalIn | date: "dd MMM yy" }}
            </span>
            <span class="ml-1">
              {{ _actualItinerary?.flights[0]?.airlineIn }} - {{ _actualItinerary?.flights[0]?.flyNumberIn }} Arr:
              {{ getHourFly(_actualItinerary?.flights[0]?.arrivalIn) }} {{ _actualItinerary?.flights[0]?.airportIataCodeIn }}
            </span>
          </p>
        </div>
        <div
          *ngIf="_actualItinerary?.flights[0]?.departureOut"
          class="w-100 d-flex gap-1 align-items-center"
          [ngStyle]="{ 'border-right': _actualItinerary?.flights[0]?.arrivalIn ? '1px solid #dfdfdf:' : '' }"
        >
          <img class="ml-3 mr-2" width="28px" style="transform: rotate(25deg)" src="../../../../assets/icons/itinerary/AVIONLINEA.svg" alt="" />

          <p class="mb-0 ml-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 11px">
            <span style="font-weight: 600; color: #444f5d;">
              {{ _actualItinerary?.flights[0]?.departureOut | date: "dd MMM yy" }}
            </span>
            <span class="ml-1">
              {{ _actualItinerary?.flights[0]?.airlineOut }} - {{ _actualItinerary?.flights[0]?.flyNumberOut }} Dep:
              {{ getHourFly(_actualItinerary?.flights[0]?.departureOut) }} {{ _actualItinerary?.flights[0]?.airportIataCodeOut }}
            </span>
          </p>
        </div>
      </div>
    </div>

    <!-- Tooltip Internal Flight Information -->
    <ng-container *ngIf="tooltipFlight && flightsInternal && flightsInternal.length > 0">
      <div
        class="d-flex justify-content-between align-items-center w-100 shadow-md"
        style="
          border: 1px solid #dfdfdf;
          border-radius: 6px;
          padding-top: 0.35em;
          padding-bottom: 0.35em;
          background-color: #f3fef9;
          position: absolute;
          bottom: -103px;
          z-index: 99999;
        "
      >
        <div class="d-flex justify-content-between align-items-start px-4" style="width: 100%">
          <ng-container *ngFor="let fly of getFlyArr(_actualItinerary?.flights); let i = index">
            <div class="d-flex flex-column align-items-center" style="min-width: 110px;">
              <img src="../../../assets/icons/itinerary/lugar.svg" style="width: 40px;" alt="" />
              <p
                class="mb-0"
                style="font-family: &quot;Rubik&quot;, serif; font-weight: 600; color: #000000;"
              >
                {{ getDataTooltip(fly, i, "iata") }}
              </p>
              <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-weight: 500; text-transform: capitalize">
                {{ getDataTooltip(fly, i, "date") | date: "dd MMM" }}
              </p>
              <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-weight: 400">
                {{ getHourFly(getDataTooltip(fly, i, "date")) }}
              </p>
              <!-- (i !== _actualItinerary?.flights.length - 1)  ? (getHourFly(fly?.arrivalIn)+' / '+getHourFly(fly?.departureIn)) : (getHourFly(fly?.departureOut)+' / '+getHourFly(fly?.arrivalOut)) -->
            </div>
            <div class="d-flex align-items-center" style="width: 80%" *ngIf="i !== getFlyArr(_actualItinerary?.flights).length - 1">
              <div class="mt-2" style="height: 2px; border-bottom: 2px dashed #000000; width: 75%"></div>
              <img class="mt-2 mx-2" src="../../../assets/icons/itinerary/airplane-plane-svgrepo-com.svg" style="width: 30px" alt="" />
              <div class="mt-2" style="height: 2px; border-bottom: 2px dashed #000000; width: 75%"></div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Flight Form -->
<ng-template #template style="background: transparent">
  <!-- *ngIf="_formFlights" -->
  <!--  -->
  <form [formGroup]="_formFlights" (ngSubmit)="_flightsApply()">
    <!-- <input type="hidden" name="valueAirlineIn" ng-model="valueAirlineIn" /> -->
    <div class="row justify-content-between px-4 py-5 align-items-center" style="height: 70px">
      <h3
        *ngIf="component !== 'fly'"
        class="semiblack"
        style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 24px; padding: 0.9em 1.8em"
      >
        {{ _actualItinerary?.flights.length === 0 ? "Nuevo vuelo" : "Vuelo general" }}
      </h3>
      <h3
        *ngIf="component === 'fly'"
        class="semiblack"
        style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 24px; padding: 0.9em 1.8em"
      >
        Vuelo de file {{ flyShowComponent?.itineraries?.id }}
      </h3>

      <div *ngIf="_actualItinerary.flights && _actualItinerary.flights.length > 0" class="d-flex pr-4 align-items-center" style="gap: 1em">
        <button
          *ngIf="(flightsInternal && flightsInternal.length === 0) || flightsInternalIds()"
          type="button"
          style="border: none; width: 25px; margin-top: 3px; background-color: transparent"
          tooltip="Crear vuelo interno"
          (click)="createFlyInternal()"
          placement="bottom"
        >
          <i class="fa fa-plus-square-o" style="font-size: 19px; -webkit-text-stroke: 0.5px" aria-hidden="true"></i>
        </button>
        <img
          *ngIf="flightsInternal && flightsInternal.length === 0"
          width="18px"
          height="20px"
          style="cursor: pointer"
          tooltip="Eliminar vuelo"
          (click)="_removeFlight(_actualItinerary.flights[0].id, true)"
          placement="bottom"
          src="../../../../assets/icons/itinerary/delet.svg"
          alt="delete fly"
        />
      </div>
    </div>

    <div role="document" class="modal-body" id="modal-edit-flight">
      <div class="mb-4" *ngIf="onlyIn">
        <div class="d-flex text-left pl-4 pr-3 fontysizer-15 pt-4 pb-1" style="gap: 0.5em">
          <div class="d-flex" style="gap: 0.5em">
            <div
              class="d-flex justify-content-center align-items-center"
              style="width: 36px; height: 36px; border-radius: 50%; background-color: #e3e3e3"
            >
              <img width="28px" src="../../assets/icons/itinerary/AVIONLINEA.svg" alt="" style="transform: rotate(30deg)" />
            </div>
            <span class="text-plane font-Rubik pt-1">Llegada</span>
          </div>
          <div class="form-group w-100 m-0 mb-4 pt-0 pb-0 text-left d-flex flex-row justify-content-between scroll">
            <div class="position-relative w-100" *ngIf="selectedAirportIn === ''">
              <div class="w-100">
                <input
                  (valueChanged)="_myCallbackAirportIn($event)"
                  ngui-auto-complete
                  formControlName="airportIn"
                  type="text"
                  name="airportIn"
                  class="form-control font-Rubik font-inputs"
                  value-formatter="name"
                  placeholder="Aeropuerto"
                  [source]="getAutoCompleteSource('airport')"
                  display-property-name="name"
                  [list-formatter]="_myListFormatterAirport"
                  accept-user-input="false"
                  autocomplete="off"
                  loading-template="Cargando aeropuertos..."
                />
              </div>
              <div
                *ngIf="selectedAirportIn === '' && _formFlights.get('airportIn').touched"
                class="position-absolute text-danger ml-2"
                style="font-size: 12px; font-weight: 600; bottom: -20px"
              >
                Ingrese un aeropuerto y seleccione una opción
              </div>
            </div>
            <div *ngIf="selectedAirportIn !== ''" class="position-relative w-100">
              <span class="container-input-icon-cancel w-100">
                <input
                  [value]="_formFlights.get('airportIn').value?.name"
                  type="text"
                  [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
                  name="airportIn"
                  class="form-control font-Rubik font-inputs"
                  readonly
                />
                <span class="square-class-secondArrival" *ngIf="component !== 'fly'">
                  <div class="container-square-secondArrival">
                    <i
                      class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true"
                      (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar Aeropuerto de llegada"
                      placement="bottom"
                      (click)="deleteSelectedOption('airportIn')"
                    ></i>
                  </div>
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="form-group m-0 mb-4 pt-0 pb-0 text-left col-12 d-flex flex-row justify-content-between scroll" style="gap: 0.5em">
          <div class="d-flex" style="width: 100%; gap: 3px">
            <div class="w-100 position-relative" *ngIf="selectedAirlineInName === ''">
              <input
                (valueChanged)="_myCallbackAirlineIn($event)"
                ngui-auto-complete
                formControlName="airlineIn"
                type="text"
                id="airlineIn"
                name="Airline"
                class="form-control font-Rubik font-inputs"
                style="width: 100% !important"
                value-formatter="name"
                placeholder="Aerolínea"
                [source]="getAutoCompleteSource('airline')"
                display-property-name="name"
                [list-formatter]="_myListFormatterAirline"
                accept-user-input="false"
                autocomplete="off"
              />
              <div
                *ngIf="selectedAirlineInName === '' && _formFlights.get('airlineIn').touched"
                class="position-absolute text-danger ml-2"
                style="font-size: 12px; font-weight: 600; bottom: -20px"
              >
                Ingrese una aerolínea y seleccione una opción
              </div>
            </div>
            <div *ngIf="selectedAirlineInName !== ''" class="position-relative w-100">
              <span class="container-input-icon-cancel w-100">
                <input
                  [value]="selectedAirlineInName"
                  [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
                  type="text"
                  id="airlineIn"
                  name="Airline"
                  class="form-control font-Rubik font-inputs"
                  readonly
                />
                <span class="square-class-secondArrival" *ngIf="component !== 'fly'">
                  <div class="container-square-secondArrival">
                    <i
                      class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true"
                      (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar Aerolínea de llegada"
                      placement="bottom"
                      (click)="deleteSelectedOption('airlineIn')"
                    ></i>
                  </div>
                </span>
              </span>
            </div>

            <input
              formControlName="_flightNumberIn"
              type="text"
              class="form-control font-Rubik font-inputs btn-_numberfly"
              id="_flight-numberIn"
              style="width: 25% !important; background-color: #efefef; pointer-events: none"
              placeholder=""
              autocomplete="off"
              readonly
            />
          </div>
          <div class="position-relative" style="width: 40%">
            <input
              *ngIf="component !== 'fly'"
              formControlName="flightNumberIn"
              style="width: 100%"
              type="text"
              class="form-control font-Rubik font-inputs btn-numberfly"
              id="flight-numberIn"
              placeholder="Número de Vuelo"
              maxlength="4"
            />
            <input
              *ngIf="component === 'fly'"
              formControlName="flightNumberIn"
              [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
              style="width: 100%"
              type="text"
              class="form-control font-Rubik font-inputs btn-numberfly"
              id="flight-numberIn"
              placeholder="Número de Vuelo"
              maxlength="4"
              readonly
            />
            <div
              *ngIf="_formFlights.get('flightNumberIn').touched && _formFlights.get('flightNumberIn').invalid"
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
            >
              Ingrese número de vuelo
            </div>
          </div>
        </div>

        <div class="form-group m-0 pt-0 pb-0 text-left col-12 d-flex flex-row align-items-center" style="gap: 0.5em">
          <div class="date-field-wrapper" style="width: 100%; position: relative">
            <input
              formControlName="arrivalDateIn"
              type="text"
              class="form-control font-Rubik font-inputs"
              id="arrivalDateIn"
              placeholder="Fecha de llegada"
              [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
              autocomplete="off"
              bsDatepicker
              [minDate]="minDate"
              [bsConfig]="dpConfig"
              readonly
            />

            <!-- X button to clear the date — only visible when date is set and component is editable -->
            <span
              *ngIf="_formFlights.get('arrivalDateIn').value && component !== 'fly'"
              class="square-class-secondArrival"
              style="right: 2.5em"
            >
              <div class="container-square-secondArrival">
                <i
                  class="bi bi-x x-icon-cancel"
                  (mouseenter)="isHoveredCancelDate = true"
                  (mouseleave)="isHoveredCancelDate = false"
                  tooltip="Eliminar fecha de llegada"
                  placement="bottom"
                  (click)="_clearDate('arrivalDateIn')"
                ></i>
              </div>
            </span>

            <span
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
              *ngIf="_formFlights.get('arrivalDateIn').touched && _formFlights.get('arrivalDateIn').invalid"
              >Ingrese una fecha de llegada</span
            >
          </div>
          <div style="width: 39%; gap: 2px;" class="d-flex flex-column">
            <div class="wheel-picker-wrapper" [class.disabled-wrapper]="!_formFlights.get('arrivalDateIn').value">
              <input
                type="text"
                class="form-control font-Rubik font-inputs"
                [value]="_formFlights.get('arrivalHourIn').value || currentTime"
                [ngStyle]="{ 'pointer-events': (component === 'fly' || !_formFlights.get('arrivalDateIn').value) ? 'none' : 'auto', 'background-color': !_formFlights.get('arrivalDateIn').value ? '#efefef' : '#FFFFFF', 'color': !_formFlights.get('arrivalDateIn').value ? '#000000' : 'auto' }"
                (input)="_onManualTimeInput($event, 'arrivalHourIn')"
                (blur)="_onTimeInputBlur('arrivalHourIn', $event)"
                placeholder="HH:MM"
                inputmode="numeric"
                maxlength="5"
                pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
              >
              <img src="../../../../../assets/icons/search-box/reloj-traslado.svg"
                width="20px"
                style="position: absolute;right: 1em;top:29%; cursor: pointer;"
                [ngStyle]="{ 'cursor': _formFlights.get('arrivalDateIn').value ? 'pointer' : 'not-allowed', 'opacity': _formFlights.get('arrivalDateIn').value ? '1' : '0.5' }"
                (click)="_formFlights.get('arrivalDateIn').value ? toggleTimePicker('arrivalHourIn', $event) : null; $event.stopPropagation()"
                alt="">

              <!-- Dropdown with wheel picker -->
              <div class="wheel-picker-dropdown" *ngIf="activeTimePicker === 'arrivalHourIn' && _formFlights.get('arrivalDateIn').value">
                <usb-wheel-time-picker
                  formControlName="arrivalHourIn"
                  [initialValue]="_formFlights.get('arrivalHourIn').value || currentTime"
                  [minuteStep]="1"
                  [disabled]="!_formFlights.get('arrivalDateIn').value">
                </usb-wheel-time-picker>
              </div>
            </div>
            <span
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
              *ngIf="_formFlights.get('arrivalHourIn').touched && _formFlights.get('arrivalHourIn').invalid"
              >Ingrese una hora de llegada</span
            >
          </div>
        </div>
      </div>

      <ng-container *ngIf="flightsInternal && flightsInternal.length > 0">
        <p class="ml-3 mt-3 mb-2" style="font-family: &quot;Rubik&quot;, serif; font-size: 18px">Vuelos internos</p>
        <usb-form-flight-internal
          [flightsInternal]="flightsInternal"
          [getClientsSettingAppBooking]="getClientsSettingAppBooking"
          [firstFly]="_actualItinerary.flights[0]"
          [formTransports]="formTransports"
          [component]="component"
          [itineraryId]="_actualItinerary?.id"
          (formValidityChange)="onFormValidityChange($event)"
          (deleteFly)="deleteFlyInternal($event)"
          (submitFly)="submitFlyInternals()"
          (accordionStateChange)="onChildAccordionStateChange($event)"
        ></usb-form-flight-internal>
      </ng-container>

      <div *ngIf="onlyOut">
        <div class="d-flex text-left pt-0 pl-4 pr-3 fontysizer-15 pt-4 pb-1">
          <div class="d-flex" style="gap: 0.5em">
            <div
              class="d-flex justify-content-center align-items-center"
              style="width: 36px; height: 36px; border-radius: 50%; background-color: #e3e3e3"
            >
              <img width="28px" src="../../assets/icons/itinerary/AVIONLINEA.svg" alt="" />
            </div>
            <span class="text-plane font-Rubik pt-1">Salida</span>
          </div>

          <div class="form-group w-100 m-0 ml-2 mb-4 pt-0 pb-0 text-left d-flex flex-row justify-content-between scroll">
            <div class="position-relative w-100" *ngIf="selectedAirportOut === ''">
              <div class="w-100">
                <input
                  (valueChanged)="_myCallbackAirportOut($event)"
                  ngui-auto-complete
                  formControlName="airportOut"
                  type="text"
                  name="airportOut"
                  class="form-control font-Rubik font-inputs"
                  value-formatter="name"
                  placeholder="Aeropuerto"
                  [source]="getAutoCompleteSource('airport')"
                  display-property-name="name"
                  [list-formatter]="_myListFormatterAirport"
                  accept-user-input="false"
                  autocomplete="off"
                />
              </div>
              <div
                *ngIf="selectedAirportOut === '' && _formFlights.get('airportOut').touched"
                class="position-absolute text-danger ml-2"
                style="font-size: 12px; font-weight: 600; bottom: -20px"
              >
                Ingrese un aeropuerto y seleccione una opción
              </div>
            </div>
            <div *ngIf="selectedAirportOut !== ''" class="position-relative w-100">
              <span class="container-input-icon-cancel w-100">
                <input
                  [value]="_formFlights.get('airportOut').value?.name"
                  type="text"
                  [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
                  name="airportOut"
                  class="form-control font-Rubik font-inputs"
                  readonly
                />
                <span class="square-class-secondArrival" *ngIf="component !== 'fly'">
                  <div class="container-square-secondArrival">
                    <i
                      class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true"
                      (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar Aeropuerto de llegada"
                      placement="bottom"
                      (click)="deleteSelectedOption('airportOut')"
                    ></i>
                  </div>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group m-0 mb-4 pt-0 pb-0 text-left col-12 d-flex flex-row justify-content-between scroll" style="gap: 0.5em">
          <div class="d-flex" style="width: 100%; gap: 3px">
            <div class="w-100 position-relative" *ngIf="selectedAirlineOutName === ''">
              <input
                (valueChanged)="_myCallbackAirlineOut($event)"
                ngui-auto-complete
                formControlName="airlineOut"
                type="text"
                id="airlineOut"
                name="Airline"
                class="form-control font-Rubik font-inputs"
                style="width: 100% !important"
                value-formatter="name"
                placeholder="Aerolínea"
                [source]="getAutoCompleteSource('airline')"
                display-property-name="name"
                [list-formatter]="_myListFormatterAirline"
                accept-user-input="false"
                autocomplete="off"
              />
              <div
                *ngIf="selectedAirlineOutName === '' && _formFlights.get('airlineOut').touched"
                class="position-absolute text-danger ml-2"
                style="font-size: 12px; font-weight: 600; bottom: -20px"
              >
                Ingrese una aerolínea y seleccione una opción
              </div>
            </div>

            <div *ngIf="selectedAirlineOutName !== ''" class="position-relative w-100">
              <span class="container-input-icon-cancel w-100">
                <input
                  [value]="selectedAirlineOutName"
                  type="text"
                  [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
                  id="airlineOut"
                  name="Airline"
                  class="form-control font-Rubik font-inputs"
                  readonly
                />
                <span class="square-class-secondArrival" *ngIf="component !== 'fly'">
                  <div class="container-square-secondArrival">
                    <i
                      class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true"
                      (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar Aerolínea de llegada"
                      placement="bottom"
                      (click)="deleteSelectedOption('airlineOut')"
                    ></i>
                  </div>
                </span>
              </span>
            </div>

            <input
              formControlName="_flightNumberOut"
              type="text"
              class="form-control font-Rubik font-inputs btn-_numberfly"
              id="_flight-numberOut"
              style="width: 25% !important; background-color: #efefef"
              placeholder=""
              autocomplete="off"
              readonly
            />
          </div>
          <div class="position-relative" style="width: 40%">
            <input
              *ngIf="component !== 'fly'"
              formControlName="flightNumberOut"
              [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
              style="width: 100%"
              type="text"
              class="form-control font-Rubik font-inputs btn-numberfly"
              id="flight-numberOut"
              placeholder="Número de vuelo"
              maxlength="4"
            />
            <input
              *ngIf="component === 'fly'"
              formControlName="flightNumberOut"
              style="width: 100%"
              [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
              type="text"
              class="form-control font-Rubik font-inputs btn-numberfly"
              id="flight-numberOut"
              placeholder="Número de vuelo"
              maxlength="4"
              readonly
            />

            <div
              *ngIf="_formFlights.get('flightNumberOut')?.touched && _formFlights.get('flightNumberOut')?.invalid"
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
            >
              Ingrese número de vuelo
            </div>
          </div>
        </div>

        <div
          class="form-group m-0 mb-4 pt-0 pb-0 text-left col-12 d-flex flex-row align-items-center justify-content-center"
          style="gap: 0.5em"
        >
          <div class="date-field-wrapper" style="width: 100%; position: relative">
            <input
              formControlName="departureDateOut"
              type="text"
              class="form-control font-Rubik font-inputs px-3"
              id="departureDateOut"
              placeholder="Fecha de Salida"
              autocomplete="off"
              bsDatepicker
              [minDate]="_formFlights.get('arrivalDateIn').value"
              [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
              [placement]="'top'"
              [bsConfig]="dpConfig"
              readonly
            />

            <!-- X button to clear the date — only visible when date is set and component is editable -->
            <span
              *ngIf="_formFlights.get('departureDateOut').value && component !== 'fly'"
              class="square-class-secondArrival"
              style="right: 2.5em"
            >
              <div class="container-square-secondArrival">
                <i
                  class="bi bi-x x-icon-cancel"
                  (mouseenter)="isHoveredCancelDate = true"
                  (mouseleave)="isHoveredCancelDate = false"
                  tooltip="Eliminar fecha de salida"
                  placement="bottom"
                  (click)="_clearDate('departureDateOut')"
                ></i>
              </div>
            </span>

            <span
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
              *ngIf="_formFlights.get('departureDateOut').touched && _formFlights.get('departureDateOut').hasError('required')"
              >Ingrese una fecha de salida</span
            >
          </div>
          <div style="width: 39%; gap: 5px;" class="d-flex flex-column">
            <div class="wheel-picker-wrapper" [class.disabled-wrapper]="!_formFlights.get('departureDateOut').value">
              <input
                type="text"
                class="form-control font-Rubik font-inputs"
                [value]="_formFlights.get('departureHourOut').value || currentTime"
                [ngStyle]="{ 'pointer-events': (component === 'fly' || !_formFlights.get('departureDateOut').value) ? 'none' : 'auto', 'background-color': !_formFlights.get('departureDateOut').value ? '#efefef' : '#FFFFFF', 'color': !_formFlights.get('departureDateOut').value ? '#000000' : 'auto' }"
                (input)="_onManualTimeInput($event, 'departureHourOut')"
                (blur)="_onTimeInputBlur('departureHourOut', $event)"
                placeholder="HH:MM"
                inputmode="numeric"
                maxlength="5"
                pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$">
              <img src="../../../../../assets/icons/search-box/reloj-traslado.svg"
                width="20px"
                style="position: absolute;right: 1em;top:29%; cursor: pointer;"
                [ngStyle]="{ 'cursor': _formFlights.get('departureDateOut').value ? 'pointer' : 'not-allowed', 'opacity': _formFlights.get('departureDateOut').value ? '1' : '0.5' }"
                (click)="_formFlights.get('departureDateOut').value ? toggleTimePicker('departureHourOut', $event) : null; $event.stopPropagation()"
                alt="">

              <!-- Dropdown with wheel picker -->
              <div class="wheel-picker-dropdown" *ngIf="activeTimePicker === 'departureHourOut' && _formFlights.get('departureDateOut').value">
                <usb-wheel-time-picker
                  formControlName="departureHourOut"
                  [initialValue]="_formFlights.get('departureHourOut').value || currentTime"
                  [minuteStep]="1"
                  [disabled]="!_formFlights.get('departureDateOut').value">
                </usb-wheel-time-picker>
              </div>
            </div>

            <span
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
              *ngIf="_formFlights.get('departureHourOut').touched && _formFlights.get('departureHourOut').hasError('required')"
              >Ingrese una hora de salida</span
            >
          </div>
        </div>
      </div>

      <p
        class="ml-3"
        *ngIf="_actualItinerary?.flights && _actualItinerary?.flights.length === 0"
        style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 400"
      >
        Una vez creado el vuelo general podrá incorporar los vuelos internos en su file.
      </p>

      <div class="d-flex justify-content-end align-items-center p-2 mt-5 mb-4" style="gap: 1em" id="apply-btn-r">
        <button (click)="closeModal()" type="button" class="btn-sm font-Rubik btn-buscar semi-black" style="border: 1px solid #b2b2b2">
          Cerrar
        </button>
        <button
          *ngIf="component !== 'fly' && flightsInternalIds() && !isChildAccordionOpen"
          type="submit"
          class="btn-sm font-Rubik btn-buscar semi-black"
          style="border: none"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
        >
          Aceptar
        </button>
      </div>
      <div class="form-row">
        <div class="form-group col-xg-5 col-lg-5 col-xs-0 p-0 align-items-center justify-content-between"></div>
        <div class="form-group col-xg-7 col-lg-7 col-xs-0 p-0 align-items-center justify-content-between">
          <p *ngFor="let info of message" class="error-label">* {{ info }}</p>
        </div>
      </div>
    </div>
  </form>
</ng-template>
